import { render, staticRenderFns } from "./FileTypeIcon.vue.js?vue&type=template&id=6f1d7bca!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./FileTypeIcon.vue?vue&type=template&id=6f1d7bca"
import script from "./FileTypeIcon.vue.js?vue&type=script&lang=js!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./FileTypeIcon.vue?vue&type=script&lang=js"
export * from "./FileTypeIcon.vue.js?vue&type=script&lang=js!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./FileTypeIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports